import { Reducer } from 'redux';
import { PermissionState, PermissionActions, MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP, MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA, MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA, MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE, MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE, MEMBER_REGISTER_PERMISSION__UPDATE_CACHE, MEMBER_REGISTER_PERMISSION__RESET_CACHE } from './types';

const initialState: PermissionState = {
  process: {
    accessibleSteps: [],
    clauses: {},
    confirmInfo: {
      otpAuth: {}
    }
  }
};

const permissionReducer: Reducer<PermissionState, PermissionActions> = (state = initialState, action): PermissionState => {
  switch (action.type) {
    // 設置可訪問步驟
    case MEMBER_REGISTER_PERMISSION__SET_ACCESSIBLE_STEP: {
      const currentStep = action.payload.step;
      const accessibleSteps = state.process.accessibleSteps.filter((step) => step !== currentStep).concat(currentStep);
      return { ...state, process: { ...state.process, accessibleSteps } };
    }
    // 緩存「同意相關告知事項」(Step-1) 頁面資料
    case MEMBER_REGISTER_PERMISSION__SAVE_CLAUSES_PAGE_DATA: {
      return { ...state, process: { ...state.process, clauses: { ...state.process.clauses, data: action.payload.data } } };
    }
    // 緩存「確認資料」(Step-2-1) 頁面資料
    case MEMBER_REGISTER_PERMISSION__SAVE_CONFIRM_INFO_PAGE_DATA: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, data: action.payload.data } } };
    }
    // 發送 OTP 驗證碼 完成
    // 重新發送 OTP 驗證碼 完成
    case MEMBER_REGISTER_PERMISSION__SEND_OTP_DONE:
    case MEMBER_REGISTER_PERMISSION__RESEND_OTP_DONE: {
      return { ...state, process: { ...state.process, confirmInfo: { ...state.process.confirmInfo, otpAuth: { ...state.process.confirmInfo.otpAuth, otp: action.payload.response } } } };
    }
    // 更新流程資料緩存
    case MEMBER_REGISTER_PERMISSION__UPDATE_CACHE: {
      return { ...action.payload.cache };
    }
    // 重置資料緩存
    case MEMBER_REGISTER_PERMISSION__RESET_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default permissionReducer;
